{
  const _ = require('underscore');
  const log = require('./Logger');
  const validEventTypes = ['view', 'link'];
  const validBrands = ['mcom', 'bcom'];

  function createTagPromise() {
    let _resolve;
    let _reject;

    const promise = new Promise(((resolve, reject) => {
      _resolve = resolve;
      _reject = reject;
    }));

    promise.resolve = _resolve;
    promise.reject = _reject;
    promise.isSettled = false;

    return promise;
  }

  const viewTagPromise = createTagPromise();
  const tagLibPromise = createTagPromise();

  function isAllOK(eventType, data) {
    if (_.isUndefined(eventType) || _.isUndefined(data)) {
      log.error('Tag Manager Exception : eventType and/or data missing!');
      return false;
    }

    if (_.indexOf(validEventTypes, eventType) === -1) {
      log.error('Tag Manager Exception : invalid eventType!');
      return false;
    }

    return true;
  }

  function isValidBrand(brand) {
    if (_.indexOf(validBrands, brand) >= 0) {
      return true;
    }

    log.error('Tag Manager Exception : invalid brand name!');
    return false;
  }

  function hasTealiumLoaded(eventType) {
    if (_.isUndefined(window.utag)) {
      log.error('Tag Manager Exception: window.utag missing!');
      return false;
    }

    if (_.isUndefined(window.utag[eventType])) {
      log.error(`Tag Manager Exception: utag.${eventType} missing!`);
      return false;
    }

    return true;
  }

  function isAllOKToUpdateUtagData() {
    if (window.utag) {
      if (_.isUndefined(window.utag.data)) {
        log.error('Tag Manager Exception: window.utag.data missing!');
        return false;
      }
    }
    return true;
  }

  function fireTags(eventType, data) {
    window.utag[eventType](data);
  }

  function tryResolvingLibPromise() {
    if (window.utag) {
      // tagLibPromise should be fulfilled when global tealium object is present.
      // we can resolve the tagLibPromise lib if it is not already resolved.
      if (!tagLibPromise.isSettled) {
        tagLibPromise.resolve('Tag manager library already loaded');
        tagLibPromise.isSettled = true;
      }
    }
  }

  function tryResolvingViewPromise() {
    if ((window.utag) && window.utag_data && (Object.keys(window.utag_data).length > 0) && !viewTagPromise.isSettled) {
      viewTagPromise.resolve('view tag already fired.');
      viewTagPromise.isSettled = true;
    }
  }

  function fireViewTag(data) {
    tryResolvingLibPromise();

    tagLibPromise.then(() => {
      fireTags('view', data);

      // Resolve the promise so that link tags can be fired.
      if (!viewTagPromise.isSettled) {
        viewTagPromise.resolve('view tag');
        viewTagPromise.isSettled = true;
      }
    }).catch(() => {
      if (!viewTagPromise.isSettled) {
        viewTagPromise.reject('Tag library promise got rejected, thus cant fire any tags.');
        viewTagPromise.isSettled = true;
      }
    });
  }

  function fireLinkTag(data) {
    tryResolvingLibPromise();
    tryResolvingViewPromise();

    viewTagPromise.then(() => {
      fireTags('link', data);
    });
  }

  function fireEventTag(eventType, data) {
    if (eventType === validEventTypes[0]) {
      fireViewTag(data);
    } else {
      fireLinkTag(data);
    }
  }

  module.exports = {
    fireTag(eventType, data, options = { immediate: false }) {
      if (isAllOK(eventType, data)) {
        if (options.immediate) {
          if (hasTealiumLoaded(eventType)) {
            fireTags(eventType, data);
            tryResolvingLibPromise();
            tryResolvingViewPromise();
          }
        } else {
          fireEventTag(eventType, data, options);
        }
      }
    },
    updateUtagDataFireTag(eventType, data) {
      if (isAllOK(eventType, data) && isAllOKToUpdateUtagData() && window.utag) {
        delete window.utag.data.adobe_page_name;
        fireEventTag(eventType, _.extend(window.utag.data, data));
      }
    },
    loadTagLibrary(brand, environment) {
      if (_.isUndefined(window.utag)) {
        if (!isValidBrand(brand)) {
          tagLibPromise.reject(new Error(`Invalid brand name. Possible values are : ${validBrands}`));
          tagLibPromise.isSettled = true;
        } else if (_.isUndefined(environment)) {
          tagLibPromise.reject(new Error('Environment name is missing'));
          tagLibPromise.isSettled = true;
        } else {
          const scriptTag = document.createElement('script');
          scriptTag.type = 'text/javascript';
          scriptTag.async = true;
          scriptTag.onload = function () {
            tagLibPromise.resolve('Tag manager library loaded');
            tagLibPromise.isSettled = true;
          };
          scriptTag.onerror = function () {
            tagLibPromise.reject(new Error('Unable to load tag manager library'));
            tagLibPromise.isSettled = true;
          };
          const brandName = (brand === 'mcom') ? 'macys' : brand;
          scriptTag.src = `//tags.tiqcdn.com/utag/${brandName}/main/${environment}/utag.js`;
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }
      } else {
        tryResolvingLibPromise();
        tryResolvingViewPromise();
      }

      return tagLibPromise;
    },
  };
}
